var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.146,
    height: 22.234,
    viewBox: "0 0 24.146 22.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Download_322224",
    transform: "translate(-5.097 -7.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6140",
    "data-name": "Group 6140",
    transform: "translate(5.097 7.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3516",
    "data-name": "Path 3516",
    d: "M34.283,26.008c.188.188.4.376.59.563a.624.624,0,0,0,.858,0c1.4-1.288,2.763-2.575,4.158-3.836.188-.188.4-.376.59-.563.563-.537-.3-1.368-.858-.858-1.234,1.154-2.5,2.307-3.729,3.461V8.409a.6.6,0,0,0-1.207,0V24.774l-3.139-2.9c-.188-.188-.4-.376-.59-.563-.563-.537-1.422.322-.858.858C31.52,23.459,32.888,24.72,34.283,26.008Z",
    transform: "translate(-23.256 -7.825)",
    fill: "#f37b2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3517",
    "data-name": "Path 3517",
    d: "M28.009,66.035v3.971a1.134,1.134,0,0,1-.08.537A.847.847,0,0,1,27.07,71H7.137a.818.818,0,0,1-.778-.51,1.332,1.332,0,0,1-.054-.483v-4a.6.6,0,0,0-1.207,0v3.407a3.657,3.657,0,0,0,.241,1.69,2.155,2.155,0,0,0,1.851,1.1H26.936a2.562,2.562,0,0,0,.778-.08,2.1,2.1,0,0,0,1.529-2.066V66.035A.618.618,0,0,0,28.009,66.035Z",
    transform: "translate(-5.097 -49.972)",
    fill: "#f37b2d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d7ef5fed2a6f19be0c48aaad71f5bb50.svg";
export { ForwardRef as ReactComponent };